/* DillySocks — Pfeil-Navigation für die mobilen Icon-Karussells der PDP:
   "Weil uns Nachhaltigkeit & Qualität wichtig ist" ([id$='__sustainability'])
   und die Socken-Abo-Benefits ([id$='__subscription'], Sean 12.08.).

   Das Karussell selbst ist reines CSS (Scroll-Snap, siehe dillysocks-tokens.css);
   dieses Script ergänzt nur die Prev/Next-Pfeile: Klick scrollt um genau eine
   Karte (Snap zentriert sie), am Anfang/Ende wird der jeweilige Pfeil
   deaktiviert. Sichtbar sind die Pfeile nur mobil (CSS). */
(function () {
  'use strict';

  var SECTIONS = ['[id$="__sustainability"]', '[id$="__subscription"]'];

  function setup() {
    SECTIONS.forEach(function (sel) {
      var sec = document.querySelector(sel);
      if (sec) setupSection(sec);
    });
  }

  function setupSection(sec) {
    if (sec.dataset.dsIconcar === '1') return;
    /* Die Karussell-Zeile ist die Row-Gruppe, deren Kinder selbst Gruppen
       sind (die Karten). In der Abo-Sektion gibt es weitere Row-Gruppen
       (Icon+Text je Benefit) — :has grenzt sauber ab. */
    var row = sec.querySelector('.group-block-content.layout-panel-flex--row:has(> .group-block)') || sec.querySelector('.group-block-content.layout-panel-flex--row');
    if (!row || row.children.length < 2) return;
    sec.dataset.dsIconcar = '1';

    /* Anker für die absolute Positionierung: der Row-Wrapper (.group-block). */
    var host = row.closest('.group-block') || row.parentElement;
    host.style.position = 'relative';

    function mkArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ds-iconcar-arrow ds-iconcar-arrow--' + dir;
      b.setAttribute('aria-label', dir === 'prev' ? 'Vorheriges Element' : 'Nächstes Element');
      b.innerHTML = '<i class="fa-solid fa-chevron-' + (dir === 'prev' ? 'left' : 'right') + '" aria-hidden="true"></i>';
      host.appendChild(b);
      return b;
    }
    var prev = mkArrow('prev');
    var next = mkArrow('next');

    function step() {
      /* Eine Karte + Lücke; aus dem echten Layout gelesen (robust bei
         geänderten Kartenzahlen/Breiten aus dem Editor). */
      var a = row.children[0];
      var b = row.children[1];
      return b.offsetLeft - a.offsetLeft;
    }

    function update() {
      var max = row.scrollWidth - row.clientWidth;
      prev.disabled = row.scrollLeft <= 2;
      next.disabled = row.scrollLeft >= max - 2;
    }

    /* Smooth-Scroll mit hartem Fallback: Ziel ist der naechste Snap-Punkt
       (Karten-Index * Schrittweite). Zuerst animiert via CSS scroll-behavior;
       greift die Animation nicht (z.B. Hintergrund-Tab, wo Animation-Frames
       pausieren), setzt der Timeout den Wert direkt. */
    function go(dir) {
      var s = step();
      var max = row.scrollWidth - row.clientWidth;
      var idx = Math.round(row.scrollLeft / s) + dir;
      var target = Math.max(0, Math.min(max, idx * s));
      row.style.scrollBehavior = 'smooth';
      row.scrollLeft = target;
      setTimeout(function () {
        if (Math.abs(row.scrollLeft - target) > 2) {
          row.style.scrollBehavior = 'auto';
          row.scrollLeft = target;
        }
        row.style.scrollBehavior = '';
        /* Pfeil-Zustaende auch ohne Scroll-Event nachfuehren (Scroll-Events
           feuern in Hintergrund-Tabs nicht zuverlaessig). */
        update();
      }, 450);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    row.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
  /* Theme-Editor: Section wird neu gerendert. */
  document.addEventListener('shopify:section:load', setup);
})();
